module.exports = __webpack_public_path__ + "img/sample01-01.8fdd68fd.png";